import { render, staticRenderFns } from "./MandateState.vue?vue&type=template&id=0b7b6388&"
import script from "./MandateState.vue?vue&type=script&lang=ts&"
export * from "./MandateState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports